import { useMutation } from "@apollo/client/react";
import GET_USERS from "../../queries/rolesAndPermissions/getUsers";
import GET_USER from "../../queries/rolesAndPermissions/getUser";
import { UPDATE_SKYNET_USER } from "../../mutations/rolesAndPermissions/updateSkynetUser";

export const useUpdateSkynetUser = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [updateSkynetUser, { data, loading, error }] = useMutation(
    UPDATE_SKYNET_USER,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_USERS, GET_USER],
      awaitRefetchQueries: true,
    },
  );

  return { updateSkynetUser, data, loading, error };
};
